<v-loading></v-loading>
<vl-loader></vl-loader>
<div class="main">
	<router-outlet></router-outlet>
</div>
<app-custom-toaster></app-custom-toaster>
<vl-modal></vl-modal>
<vl-notification></vl-notification>
